module.exports = __webpack_public_path__ + "img/59.7e63e2f5.jpg";